import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { getRatio } from "../../components/column-ratio"
import { InheritedThemeProvider } from "@convertkit/editor"
import { colorInRGBA } from "core/utils"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-sponsorctanoimage td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .ck-sponsorctanoimage img {
      margin-top: 18px !important;
    }
  }
`

export function SponsorCTANoImage({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    imageBorderRadius: properties.imageBorderRadius,
    paddingTop: properties.verticalPadding,
    paddingRight: properties.horizontalPadding,
    paddingBottom: properties.verticalPadding,
    paddingLeft: properties.horizontalPadding,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid",
    overflow: "hidden"
  }

  return (
    <div
      className="ck-sponsorctanoimage ck-layout-block-template"
      style={containerStyle}
      bgcolor={properties.backgroundColor}
    >
      <InheritedThemeProvider
        theme={{
          paragraph: {
            color: properties.sponsorLabelColor,
            fontWeight: properties.sponsorLabelFontWeight,
            fontFamily: properties.sponsorLabelFontFamily,
            fontSize: 11,
            lineHeight: 1.2
          }
        }}
      >
        <div
          style={{
            backgroundColor: colorInRGBA(properties.sponsorLabelColor, 0.1),
            display: "inline-block",
            paddingRight: 8,
            paddingLeft: 8,
            marginBottom: 8,
            borderRadius: "3px"
          }}
        >
          <LiteSlateEditor block_id={children[0].block_id} />
        </div>
      </InheritedThemeProvider>
      <InheritedThemeProvider
        theme={{
          h3: {
            color: properties.headingColor,
            fontWeight: properties.headingFontWeight,
            fontFamily: properties.headingFontFamily
          }
        }}
      >
        <LiteSlateEditor block_id={children[1].block_id} />
      </InheritedThemeProvider>

      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              width={getRatio(properties.columnRatio, "left")}
              style={{ verticalAlign: "top", paddingRight: "16px" }}
            >
              <InheritedThemeProvider
                theme={{
                  paragraph: {
                    color: properties.textColor,
                    fontWeight: properties.textFontWeight,
                    fontFamily: properties.textFontFamily
                  }
                }}
              >
                <LiteSlateEditor block_id={children[2].block_id} />
              </InheritedThemeProvider>
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
